import React from 'react'
import PropTypes from 'prop-types'

import { Button } from '@material-ui/core'
import { unionWith } from 'lodash'

import { getDefaultMessage } from 'components/ComposeOutreachMessageButton/services/message-service'
import {
  ONE_TIME_TRIGGER,
  AUTOMATED_TRIGGER_CONFIGS,
} from 'components/SegmentSelector/outreach-message-trigger-constants'

import { withContext } from '../Context'
import './Triggers.scss'

export const ComposeActionTriggerComp = ({ children, color, segmentCriteria, showModal, size, trigger, variant }) => {
  const handleClick = () => {
    const defaultMessage = getDefaultMessage(trigger)
    const message = !segmentCriteria
      ? defaultMessage
      : Object.assign({}, defaultMessage, {
          Segment: {
            Version: 2,
            Criteria: {
              Must: unionWith(segmentCriteria, defaultMessage.Segment.Criteria.Must, (a, b) => a.Name === b.Name),
              OneOf: defaultMessage.Segment.Criteria.OneOf,
            },
          },
        })
    return showModal(message, 'new')
  }

  return (
    <Button
      variant={variant || 'contained'}
      color={color || 'primary'}
      disableElevation
      size={size || 'medium'}
      onClick={handleClick}
    >
      {children}
    </Button>
  )
}

ComposeActionTriggerComp.propTypes = {
  children: PropTypes.any.isRequired,
  color: PropTypes.string,
  segmentCriteria: PropTypes.array,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  showModal: PropTypes.func.isRequired,
  variant: PropTypes.string,
  trigger: PropTypes.oneOf([ONE_TIME_TRIGGER, ...AUTOMATED_TRIGGER_CONFIGS.map((trigger) => trigger.value)]).isRequired,
}

export const ComposeActionTrigger = withContext(ComposeActionTriggerComp)
